<div class="cookies-popup" *ngIf="showPopup">
  <div class="container">
    <div class="cookies-popup-wrp">
      <div class="popup-text">
        <h3 class="title py-2">{{ ('cookies.title' | translate) || config.title }}</h3>
        <p class="brief">{{ ('cookies.messageText' | translate) || config.messageText }}

          <a class="px-1" [href]="privacyPolicyUrl" [title]="('cookies.linkText' | translate) || config.linkText">{{ ('cookies.linkText' | translate) || config.linkText }}</a>
        </p>
      </div>
      <div class="buttons-wrapper d-flex gap-2">

        <button  aria-label="button Text"   (click)="onAllowClick()" class="btn btn-primary popup-button">
          {{ ('cookies.buttonTextOk' | translate) || config.buttonTextOk }}
        </button>
         <button  aria-label="button Text"   (click)="onDenyClick()" class="btn btn-outline-primary popup-button">
          {{ ('cookies.buttonTextCancel' | translate) || config.buttonTextCancel }}
        </button>
      </div>
    </div>
  </div>
</div>